var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPcsLogoCmyk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 226.77 147.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke:#1a1a18;stroke-miterlimit:10;stroke-width:.2px;}.cls-1,.cls-2{fill:#1a1a18;}.cls-2,.cls-3{stroke-width:0px;}.cls-3{fill:#9cbf29;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M104.01,88.93v.7c0,7.06-3.05,11.24-10.11,11.24s-10.27-4.17-10.27-11.24v-31.46c0-7.22,3.21-11.24,10.27-11.24s9.8,3.64,10.08,10.2h16.98c-.79-15.68-9.76-25.61-27.06-25.61s-27.93,10.11-27.93,28.09v28.57c0,17.98,9.95,28.09,27.93,28.09s26.86-10.6,27.11-27.35h-17Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M169.87,71.78c6.08,3.77,10.69,9.42,10.69,19.63,0,15.25-8.99,24.88-26.32,24.88-6.67,0-12.21-1.37-16.55-3.91l-27.92,35.22h117V0l-56.9,71.78Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M153.44,101.68c5.78,0,9.63-2.73,9.63-9.31,0-3.17-1.46-5.37-3.87-7.13l-11.8,14.88c1.58,1.04,3.62,1.56,6.04,1.56Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35.47,31.53c-9.63,0-16.69,5.14-19.9,14.12l-.32-12.52H0v103.13h17.66v-29.62c3.69,6.1,9.95,9.63,17.82,9.63,13.16,0,20.54-8.19,20.54-25.52v-33.87c0-17.17-7.38-25.36-20.54-25.36ZM38.36,88.67c0,7.87-2.41,12.2-9.31,12.2s-11.4-4.82-11.4-15.41v-23.11c0-10.59,4.49-15.41,11.4-15.41s9.31,4.17,9.31,12.2v29.53Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M159.54,67.01c-8.51-3.21-14.77-5.62-14.77-12.52,0-6.1,4.01-8.51,8.67-8.51,4.41,0,7.31,1.69,8.45,5.19h16.76c-1.73-12.29-11.31-19.63-25.37-19.63-16.69,0-25.52,9.31-25.52,23.75,0,16.05,10.75,21.35,21.03,25.2,8.03,2.89,14.28,5.3,14.28,11.88s-3.85,9.31-9.63,9.31c-5.03,0-8.41-2.19-9.45-6.82h-17c1.4,13.47,11.1,21.42,27.25,21.42,17.33,0,26.32-9.63,26.32-24.88s-10.75-20.54-21.03-24.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPcsLogoCmyk);
export default __webpack_public_path__ + "static/media/PCS_Logo_CMYK.933c431895f55f0ae0fbddb1799cdb12.svg";
export { ForwardRef as ReactComponent };